import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Alert,
} from '@mui/material';
import { Cancel as CancelIcon } from '@mui/icons-material';
import { paymentsApi } from '../services/api';

const PaymentCancel: React.FC = () => {
    const [searchParams] = useSearchParams();
    const [error, setError] = useState<string | null>(null);
    const [cancellationStatus, setCancellationStatus] = useState<string | null>(null);

    useEffect(() => {
        const sessionId = searchParams.get('session_id');
        if (sessionId) {
          paymentsApi.cancelOrder(sessionId);
        } else {
          setError('No session ID found');
          setCancellationStatus('error');
        }
      }, [searchParams]);
    
  const navigate = useNavigate();

  const handleGoToAccount = () => {
    navigate('/user/account');
  };

  const handleGoToDashboard = () => {
    navigate('/user/');
  };

  const handleTryAgain = () => {
    navigate('/user/account');
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="400px"
      padding={3}
    >
      <Card sx={{ maxWidth: 600, width: '100%' }}>
        <CardContent sx={{ textAlign: 'center', py: 4 }}>
          <CancelIcon 
            color="error" 
            sx={{ fontSize: 80, mb: 2 }} 
          />

          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}
          
          <Typography variant="h4" gutterBottom color="error.main">
            Payment Cancelled
          </Typography>
          
          <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
            Your payment was cancelled. No charges have been made to your account.
          </Typography>

          <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
            If you'd like to purchase credits, you can try again from your account page.
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button 
              variant="contained" 
              onClick={handleTryAgain}
              size="large"
            >
              Try Again
            </Button>
            <Button 
              variant="outlined" 
              onClick={handleGoToDashboard}
              size="large"
            >
              Go to Dashboard
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PaymentCancel;
